import Button from 'devextreme-react/button';
import { useState } from 'react';
import { confirm } from 'devextreme/ui/dialog';
import { Toast } from 'devextreme-react/toast';
import { Tooltip } from 'devextreme-react/tooltip';
import * as action from '../../../actions/gallery';


const FileCard = (props) => {
    const { file, dispatch } = { ...props }
    const [loading, setLoading] = useState(true)
    const [showTooltip, setShowTooltip] = useState(false)
    const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });

    const handleImageLoad = () => {
        setLoading(false)
    }

    const handleDelete = (id) => {
        let result = confirm("Confirm Delete?", "Confirm changes");
        result.then((res) => {
            if (res) {
                action.deleteGalleryFile(dispatch, id)
                setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'File Delete Successful' });
            }
        })
    }

    const handleCopyUrl = (url) => {
        navigator.clipboard.writeText(url);
        setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'URL Copied' });
    }

    const handlePreview = (url) => {
        window.open(url)
    }

    const toggleShowTooltip = () => {
        setShowTooltip(cur => !cur)
    }

    return (
        <>
            {loading && <div style={{ display: loading ? "block" : "none" }}>Loading...</div>}
            <div style={{ position: "relative", display: loading ? "none" : "block" }}>
                <div className="file_header" style={{padding:".15rem"} }>
                        <div style={{ paddingLeft: "1rem", color: "gray" }}>
                            <h4>{file.fileName}</h4>
                        </div>
                        <div style={{ display: "flex" }}>
                            <Button icon="trash" onClick={() => handleDelete(file.id)} />
                        <div onMouseEnter={toggleShowTooltip} onMouseLeave={toggleShowTooltip} >
                            <Button icon="copy" onClick={() => handleCopyUrl(file.publicURL)} id={"copy_" + file.id} />
                                <Tooltip
                                    target={"#copy_" + file.id}
                                    visible={showTooltip}
                                    hideOnOutsideClick={false}
                                >
                                    <div> Copy URL</div>
                                </Tooltip>
                            </div>
                            <Button icon="fas fa-eye" onClick={() => handlePreview(file.publicURL)} />
                        </div>
                </div>
                <img src={file.publicURL} alt={file.fileName} style={{ objectFit: "cover", width: "100%", height: "200px" }} onLoad={handleImageLoad} />
            </div>
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={() => setToastConfig({
                    ...toastConfig,
                    isVisible: false,
                })}
                displayTime={1000}
            />
        </>
    )
}

export default FileCard